import { mapActions } from 'vuex';
import debounce from 'lodash.debounce';

export default {
  data() {
    return {
      resizeCallback: null,
    };
  },
  mounted() {
    this.resizeCallback = debounce(() => {
      this.refreshWindowSize();
    }, 0);
    window.addEventListener('resize', this.resizeCallback);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeCallback);
  },
  methods: {
    ...mapActions({
      refreshWindowSize: 'refreshWindowSize',
    }),
  },
};
